module.exports = __webpack_public_path__ + "static/media/ic_general_train_black.15f9fb75.svg";